import { Box } from "@mui/material";
import { forwardRef, ReactNode } from "react";
import { Line, Order } from "../types";
import EntryLines from "./components/EntryLines/EntryLines";

interface EntryProps {
  order: Order;
  save: (lines: Line[]) => void;
  continueToNextButton: ReactNode;
  cancelOrderButton: ReactNode;
}

const Entry = forwardRef(
  (
    { order, save, continueToNextButton, cancelOrderButton }: EntryProps,
    ref
  ) => (
    <Box data-testid="order-entry-screen">
      <EntryLines
        order={order}
        save={save}
        ref={ref}
        continueToNextButton={continueToNextButton}
        cancelOrderButton={cancelOrderButton}
      />
    </Box>
  )
);

export default Entry;
